export enum LangLabel {
  ru = 'Русский',
  en = 'English',
}

export enum LangShortLabel {
  ru = 'Ru',
  en = 'Eng',
}

export enum LangKey {
  ru = 'ru',
  en = 'en',
}

export type LangSelectProfile = {
  label: LangLabel;
  shortLabel: LangShortLabel;
  keyLanguage: LangKey;
  value: string;
};

export const APP_DEFAULT_LANGUAGE_KEY = LangKey.en;
